/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Store } from '../../models/store';
import { StoreInput } from '../../models/store-input';

export interface CreateStore$Params {
  'Active-Tenant-Identifier': string;
      body: StoreInput
}

export function createStore(http: HttpClient, rootUrl: string, params: CreateStore$Params, context?: HttpContext): Observable<StrictHttpResponse<Store>> {
  const rb = new RequestBuilder(rootUrl, createStore.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Store>;
    })
  );
}

createStore.PATH = '/stores';
